import React from 'react';
import { useTranslation } from 'react-i18next';
import Stack from 'components/Stack';
import Heading from 'components/Heading';
import Spinner from 'components/Spinner';
import Flex from 'components/Flex';
import Text from 'components/Text';
import Button from 'components/Button';
import Icon from 'components/Icon';
import { useFetchMyCalendarSettings } from './hooks/useFetchMyCalendarSettings';
import { useDisconnectMyCalendar } from './hooks/useDisconnectMyCalendar';
function LinkedStatus(_ref) {
  var isLinked = _ref.isLinked,
    provider = _ref.provider,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useDisconnectMyCalen = useDisconnectMyCalendar(),
    disconnectMyCalendar = _useDisconnectMyCalen.disconnectMyCalendar,
    isLoading = _useDisconnectMyCalen.isLoading;
  var linkMyCalendar = function linkMyCalendar(provider) {
    var url = "/api/me/calendar/".concat(provider, "/auth");
    window.open(url, '_blank', 'noopener');
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, null, isLinked ? /*#__PURE__*/React.createElement(Flex, {
    gap: "xxs"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "ok",
    color: "alert-success"
  }), t('Linked')) : /*#__PURE__*/React.createElement(Flex, {
    gap: "xxs"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "x",
    color: "alert-fail"
  }), t('Not linked'))), isLinked ? /*#__PURE__*/React.createElement(Button, {
    size: "small",
    onClick: function onClick() {
      return disconnectMyCalendar(provider);
    },
    isDisabled: isLoading || isDisabled
  }, t('Disconnect')) : /*#__PURE__*/React.createElement(Button, {
    size: "small",
    onClick: function onClick() {
      return linkMyCalendar(provider);
    },
    isDisabled: isDisabled
  }, t('Connect')));
}
function UserCalendarIntegration() {
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var _useFetchMyCalendarSe = useFetchMyCalendarSettings(),
    data = _useFetchMyCalendarSe.data,
    isLoading = _useFetchMyCalendarSe.isLoading;
  var isLinkedToGoogle = (data === null || data === void 0 ? void 0 : data.provider) === 'google' && (data === null || data === void 0 ? void 0 : data.hasAccountLinked);
  var isLinkedToMicrosoft = (data === null || data === void 0 ? void 0 : data.provider) === 'microsoft' && (data === null || data === void 0 ? void 0 : data.hasAccountLinked);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    mb: "s"
  }, t('Link your calendar')), isLoading ? /*#__PURE__*/React.createElement(Spinner, {
    dimmed: true
  }) : /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row",
    gap: "s"
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, t('Google Calendar')), /*#__PURE__*/React.createElement(LinkedStatus, {
    isLinked: isLinkedToGoogle,
    provider: "google",
    isDisabled: isLinkedToMicrosoft
  })), /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row",
    gap: "s"
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, t('Microsoft Calendar')), /*#__PURE__*/React.createElement(LinkedStatus, {
    isLinked: isLinkedToMicrosoft,
    provider: "microsoft",
    isDisabled: isLinkedToGoogle
  }))));
}
export default UserCalendarIntegration;